import React from "react";
import { Modal } from "react-bootstrap";
import { useAppContext } from "../providers/app-context";

const SuccessModal = () => {
  const app = useAppContext();
  const onClose = () => {
    app.successModal.close();
  };

  return (
    <>
      <Modal show={app.successModal.isOpen} onHide={onClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {app.successModal.header && app.successModal.header !== "" && (
            <h3 className="text-center mb-2">{app.successModal.header}</h3>
          )}

          <p className="text-center mb-2">{app.successModal.body}</p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SuccessModal;
